import DeleteLeftFill from './DeleteLeftFill';

export default DeleteLeftFill;
